module.exports = __webpack_public_path__ + "static/media/address.2a30d0c5.svg";